import React, { useState } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { useAlert } from '../context/AlertContext';
import orderService from '../services/orderService';

const normOrarioConfigurator = (raw) => {
  if (raw === null || raw === undefined) return '';
  return String(raw).trim().replace(',', '.');
};

const isOrariobloccoDestZeroish = (v) => {
  if (v === null || v === undefined) return true;
  const s = String(v).trim();
  if (s === '') return true;
  const n = Number(s.replace(',', '.'));
  if (Number.isFinite(n) && n === 0) return true;
  return s === '0' || s === '0,0' || s === '0.0';
};

const EditClienteCredenziali = ({ 
  clienteForm, 
  handleFormChange, 
  darkMode,
  index, 
  dest,
  isNewCliente = false,
  isNuovaDestinazione = false,
  validationErrors = {},
  orarioBloccoGenerale = null,
}) => {
  const { showAlertGlobal } = useAlert();
  const [showPassword, setShowPassword] = useState({});

  const getAbilitaBlocco = () => {
    if (isNewCliente) return String(clienteForm.abilita_blocco ?? '0').trim() === '1' ? '1' : '0';
    const v = clienteForm.destinazioni_clie?.[index]?.abilita_blocco ?? dest.abilita_blocco ?? '0';
    return String(v).trim() === '1' ? '1' : '0';
  };

  const getOrarioDestStored = () =>
    isNewCliente
      ? clienteForm.orarioblocco_dest
      : clienteForm.destinazioni_clie?.[index]?.orarioblocco_dest ?? dest.orarioblocco_dest;

  const getOrarioDestDisplayValue = () => {
    const stored = getOrarioDestStored();
    if (!isOrariobloccoDestZeroish(stored)) return normOrarioConfigurator(stored);
    return normOrarioConfigurator(orarioBloccoGenerale) || '';
  };

  const setAbilitaBlocco = (checked) => {
    const v = checked ? '1' : '0';
    if (isNewCliente) handleFormChange('abilita_blocco', v);
    else handleFormChange('abilita_blocco', v, 'destinazioni_clie', index);
  };

  const setOrarioDest = (val) => {
    if (isNewCliente) handleFormChange('orarioblocco_dest', val);
    else handleFormChange('orarioblocco_dest', val, 'destinazioni_clie', index);
  };

  // Funzione per mostrare/nascondere password
  const togglePasswordVisibility = (idx) => {
    setShowPassword(prev => ({
      ...prev,
      [idx]: !prev[idx]
    }));
  };

  // Funzione per generare password random
  const generateRandomPassword = (idx) => {
    const length = 8;
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ" + 
                  "abcdefghijklmnopqrstuvwxyz" + 
                  "0123456789";
    let password = '';
    
    // Assicura almeno un carattere di ogni tipo (solo alfanumerico)
    password += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[Math.floor(Math.random() * 26)]; // Maiuscola
    password += 'abcdefghijklmnopqrstuvwxyz'[Math.floor(Math.random() * 26)]; // Minuscola
    password += '0123456789'[Math.floor(Math.random() * 10)]; // Numero
    
    // Completa con caratteri random
    for (let i = password.length; i < length; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    
    // Mescola la password
    password = password.split('').sort(() => Math.random() - 0.5).join('');
    
    // Aggiorna il campo password
    handleFormChange('destpsw', password, 'destinazioni_clie', idx);
    
    // Mostra la password generata
    setShowPassword(prev => ({
      ...prev,
      [idx]: true
    }));
    
  };

  // Funzione per inviare credenziali cliente via email
  const handleInvioCredenziali = async (idx) => {
    try {
      const destinazione = clienteForm.destinazioni_clie?.[idx] || dest;
      
      if (!destinazione.destlogin) {
        showAlertGlobal('Username mancante per l\'invio delle credenziali', 'warning');
        return;
      }

      const datiCredenziali = {
        ragionesociale: destinazione.nomede || 'Cliente',
        nomedestinazione: destinazione.nomede || 'Destinazione',
        username: destinazione.destlogin,
        password: destinazione.destpsw || '',
        urlaccesso: window.location.origin
      };

      console.log('📧 Invio credenziali:', datiCredenziali);
      
      await orderService.invioCredenzialiCliente(datiCredenziali);
      showAlertGlobal('✅ Credenziali inviate via email con successo!', 'success');
      
    } catch (error) {
      console.error('❌ Errore nell\'invio delle credenziali:', error);
      showAlertGlobal('Errore nell\'invio delle credenziali via email', 'danger');
    }
  };

  return (
    <>
      {/* Sezione Credenziali Cliente - Username e Password nascosti per nuova destinazione */}
      <hr />
      <h6><i className="fas fa-key me-2"></i>Credenziali Cliente</h6>
      <Row>
        {!isNuovaDestinazione && (
          <>
            <Col md={4}>
              <Form.Group className="mb-2">
                <Form.Label><strong>Username:</strong></Form.Label>
                <Form.Control
                  type="text"
                  value={clienteForm.destinazioni_clie?.[index]?.destlogin || dest.destlogin || ''}
                  onChange={(e) => handleFormChange('destlogin', e.target.value, 'destinazioni_clie', index)}
                  placeholder="Username di accesso"
                  isInvalid={!!validationErrors.destlogin}
                  className={darkMode ? 'bg-dark text-light border-secondary' : ''}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-2">
                <Form.Label><strong>Password:</strong></Form.Label>
                <div className="d-flex gap-1">
                  <div className="position-relative flex-grow-1">
                    <Form.Control
                      type={showPassword[index] ? "text" : "password"}
                      value={clienteForm.destinazioni_clie?.[index]?.destpsw || dest.destpsw || ''}
                      onChange={(e) => handleFormChange('destpsw', e.target.value, 'destinazioni_clie', index)}
                      placeholder="Password di accesso"
                      isInvalid={!!validationErrors.destpsw}
                      className={darkMode ? 'bg-dark text-light border-secondary' : ''}
                      style={{ paddingRight: '40px' }}
                    />
                    <Button
                      variant="link"
                      size="sm"
                      onClick={() => togglePasswordVisibility(index)}
                      title={showPassword[index] ? "Nascondi password" : "Mostra password"}
                      style={{
                        position: 'absolute',
                        right: '5px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        padding: '0',
                        border: 'none',
                        background: 'transparent',
                        color: darkMode ? '#adb5bd' : '#6c757d'
                      }}
                    >
                      <i className={`fas ${showPassword[index] ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                    </Button>
                  </div>
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={() => generateRandomPassword(index)}
                    title="Genera password random"
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    <i className="fas fa-random"></i>
                  </Button>
                </div>
              </Form.Group>
            </Col>
          </>
        )}
        <Col md={isNuovaDestinazione ? 12 : 4}>
          <Form.Group className="mb-2">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <Form.Label className="mb-0"><strong>Ordini Attivi:</strong></Form.Label>
              <Form.Check
                type="switch"
                label={
                  (clienteForm.destinazioni_clie?.[index]?.orderactive || dest.orderactive || '0') === '1' 
                    ? 'Attivo' 
                    : 'Disattivo'
                }
                checked={(clienteForm.destinazioni_clie?.[index]?.orderactive || dest.orderactive || '0') === '1'}
                onChange={(e) => handleFormChange('orderactive', e.target.checked ? '1' : '0', 'destinazioni_clie', index)}
                className="text-end"
              />
            </div>
            {!isNewCliente && (
              <Button
                variant="primary"
                size="sm"
                onClick={() => handleInvioCredenziali(index)}
                title="Invia credenziali via email"
                style={{ whiteSpace: 'nowrap' }}
              >
                <i className="fas fa-envelope me-1"></i>
                Invia Credenziali
              </Button>
            )}
          </Form.Group>
        </Col>
      </Row>
      
      {/* Sezione Giorni della Settimana */}
      <hr />
      <h6><i className="fas fa-calendar-week me-2"></i>Disabilitazione Ordini per Giorno</h6>
      <Row>
        <Col xs={6} sm={3} lg={1}>
          <Form.Group className="mb-2">
            <Form.Label 
              className="d-block text-center"
              style={{
                color: (clienteForm.destinazioni_clie?.[index]?.lun_act || dest.lun_act || '0') === '1' ? '#dc3545' : 'inherit'
              }}
            >
              <small><strong>Lun</strong></small>
            </Form.Label>
            <Form.Check
              type="switch"
              checked={(clienteForm.destinazioni_clie?.[index]?.lun_act || dest.lun_act || '0') === '1'}
              onChange={(e) => handleFormChange('lun_act', e.target.checked ? '1' : '0', 'destinazioni_clie', index)}
              className="d-flex justify-content-center"
            />
          </Form.Group>
        </Col>
        <Col xs={6} sm={3} lg={1}>
          <Form.Group className="mb-2">
            <Form.Label 
              className="d-block text-center"
              style={{
                color: (clienteForm.destinazioni_clie?.[index]?.mar_act || dest.mar_act || '0') === '1' ? '#dc3545' : 'inherit'
              }}
            >
              <small><strong>Mar</strong></small>
            </Form.Label>
            <Form.Check
              type="switch"
              checked={(clienteForm.destinazioni_clie?.[index]?.mar_act || dest.mar_act || '0') === '1'}
              onChange={(e) => handleFormChange('mar_act', e.target.checked ? '1' : '0', 'destinazioni_clie', index)}
              className="d-flex justify-content-center"
            />
          </Form.Group>
        </Col>
        <Col xs={6} sm={3} lg={1}>
          <Form.Group className="mb-2">
            <Form.Label 
              className="d-block text-center"
              style={{
                color: (clienteForm.destinazioni_clie?.[index]?.mer_act || dest.mer_act || '0') === '1' ? '#dc3545' : 'inherit'
              }}
            >
              <small><strong>Mer</strong></small>
            </Form.Label>
            <Form.Check
              type="switch"
              checked={(clienteForm.destinazioni_clie?.[index]?.mer_act || dest.mer_act || '0') === '1'}
              onChange={(e) => handleFormChange('mer_act', e.target.checked ? '1' : '0', 'destinazioni_clie', index)}
              className="d-flex justify-content-center"
            />
          </Form.Group>
        </Col>
        <Col xs={6} sm={3} lg={1}>
          <Form.Group className="mb-2">
            <Form.Label 
              className="d-block text-center"
              style={{
                color: (clienteForm.destinazioni_clie?.[index]?.gio_act || dest.gio_act || '0') === '1' ? '#dc3545' : 'inherit'
              }}
            >
              <small><strong>Gio</strong></small>
            </Form.Label>
            <Form.Check
              type="switch"
              checked={(clienteForm.destinazioni_clie?.[index]?.gio_act || dest.gio_act || '0') === '1'}
              onChange={(e) => handleFormChange('gio_act', e.target.checked ? '1' : '0', 'destinazioni_clie', index)}
              className="d-flex justify-content-center"
            />
          </Form.Group>
        </Col>
        <Col xs={6} sm={3} lg={1}>
          <Form.Group className="mb-2">
            <Form.Label 
              className="d-block text-center"
              style={{
                color: (clienteForm.destinazioni_clie?.[index]?.ven_act || dest.ven_act || '0') === '1' ? '#dc3545' : 'inherit'
              }}
            >
              <small><strong>Ven</strong></small>
            </Form.Label>
            <Form.Check
              type="switch"
              checked={(clienteForm.destinazioni_clie?.[index]?.ven_act || dest.ven_act || '0') === '1'}
              onChange={(e) => handleFormChange('ven_act', e.target.checked ? '1' : '0', 'destinazioni_clie', index)}
              className="d-flex justify-content-center"
            />
          </Form.Group>
        </Col>
        <Col xs={6} sm={3} lg={1}>
          <Form.Group className="mb-2">
            <Form.Label 
              className="d-block text-center"
              style={{
                color: (clienteForm.destinazioni_clie?.[index]?.sab_act || dest.sab_act || '0') === '1' ? '#dc3545' : 'inherit'
              }}
            >
              <small><strong>Sab</strong></small>
            </Form.Label>
            <Form.Check
              type="switch"
              checked={(clienteForm.destinazioni_clie?.[index]?.sab_act || dest.sab_act || '0') === '1'}
              onChange={(e) => handleFormChange('sab_act', e.target.checked ? '1' : '0', 'destinazioni_clie', index)}
              className="d-flex justify-content-center"
            />
          </Form.Group>
        </Col>
        <Col xs={6} sm={3} lg={1}>
          <Form.Group className="mb-2">
            <Form.Label 
              className="d-block text-center"
              style={{
                color: (clienteForm.destinazioni_clie?.[index]?.dom_act || dest.dom_act || '0') === '1' ? '#dc3545' : 'inherit'
              }}
            >
              <small><strong>Dom</strong></small>
            </Form.Label>
            <Form.Check
              type="switch"
              checked={(clienteForm.destinazioni_clie?.[index]?.dom_act || dest.dom_act || '0') === '1'}
              onChange={(e) => handleFormChange('dom_act', e.target.checked ? '1' : '0', 'destinazioni_clie', index)}
              className="d-flex justify-content-center"
            />
          </Form.Group>
        </Col>
        <Col xs={6} sm={3} lg={1}>
          <Form.Group className="mb-2">
            <Form.Label 
              className="d-block text-center"
              style={{
                color: (clienteForm.destinazioni_clie?.[index]?.spec_act || dest.spec_act || '0') === '1' ? '#dc3545' : 'inherit'
              }}
            >
              <small><strong>Spec</strong></small>
            </Form.Label>
            <Form.Check
              type="switch"
              checked={(clienteForm.destinazioni_clie?.[index]?.spec_act || dest.spec_act || '0') === '1'}
              onChange={(e) => handleFormChange('spec_act', e.target.checked ? '1' : '0', 'destinazioni_clie', index)}
              className="d-flex justify-content-center"
            />
          </Form.Group>
        </Col>
      </Row>

      <hr className="my-3 border-secondary" />
      <h6 className="mb-2">
        <i className="fas fa-clock me-2"></i>
        Blocco ordini (override per destinazione)
      </h6>
      <Row className="align-items-end">
        <Col xs={12} md={5} className="mb-2 mb-md-0">
          <Form.Group>
            <div className="d-flex justify-content-between align-items-center gap-2 flex-wrap">
              <Form.Label className="mb-0">
                <strong>Abilita orario personalizzato</strong>
              </Form.Label>
              <Form.Check
                type="switch"
                id={`abilita-blocco-${isNewCliente ? 'nuovo' : index}`}
                label={getAbilitaBlocco() === '1' ? 'Sì' : 'No'}
                checked={getAbilitaBlocco() === '1'}
                onChange={(e) => setAbilitaBlocco(e.target.checked)}
                className="text-end"
              />
            </div>
            <Form.Text className="text-muted d-block mt-1">
              Se attivo, gli utenti non amministratori usano l&apos;orario sotto al posto di quello aziendale (ORARIOBLOCCO).
            </Form.Text>
          </Form.Group>
        </Col>
        <Col xs={12} md={7}>
          <Form.Group>
            <Form.Label>
              <strong>Orario blocco ordini (destinazione)</strong>
            </Form.Label>
            <Form.Control
              type="text"
              name="orarioblocco_dest"
              value={getOrarioDestDisplayValue()}
              onChange={(e) => setOrarioDest(e.target.value)}
              placeholder={normOrarioConfigurator(orarioBloccoGenerale) || 'es. 22.30'}
              disabled={getAbilitaBlocco() !== '1'}
              className={darkMode ? 'bg-dark text-light border-secondary' : ''}
            />
            <Form.Text className="text-muted">
              Formato come in configurazione (es. 15.30 o 22,30). Se vuoto o 0, in salvataggio si usa l&apos;orario ORARIOBLOCCO generale.
            </Form.Text>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default EditClienteCredenziali;